import { createI18n } from "vue-i18n";
import { getSiteAccessLocale } from "@assets/js/imaios-global/imaios-global";
import enAnatomicalTrad from "@translations/anatomical-structures/anatomical-structures.en.json";
import enSearchTrad from "@translations/search/search.en.json";

// Simple interpolation function for %placeholders%
function interpolate(message, values = {}) {
  return typeof message === "string"
    ? message.replace(/%(\w+)%/g, (_, key) => values?.[key] ?? "")
    : message;
}
export default async function () {
  const siteAccess = getSiteAccessLocale();

  // Dynamically import all translation JSONs
  const anatomicalTrad = import.meta.glob(
    "/translations/anatomical-structures/anatomical-structures.??.json",
    { import: "default" }
  )[
    `/translations/anatomical-structures/anatomical-structures.${siteAccess}.json`
  ];
  const searchTrad = import.meta.glob("/translations/search/search.??.json", {
    import: "default",
  })[`/translations/search/search.${siteAccess}.json`];

  // Combine translations for this locale
  async function loadTranslations() {
    const [anatomicalMessages, searchMessages] = await Promise.all([
      anatomicalTrad(),
      searchTrad(),
    ]);
    return {
        ...anatomicalMessages,
        ...searchMessages,
    };
  }

  const messages = {
    [siteAccess]: await loadTranslations(),
    en: {...enAnatomicalTrad, ...enSearchTrad}
  };

  const i18n = createI18n({
    locale: siteAccess,
    fallbackLocale: "en",
    legacy: false,
    messages,
  });
  // Patch $t to support %placeholders%
  const originalT = i18n.global.t;
  i18n.global.t = (key, values) => {
    const rawMessage = originalT(key, values);
    return interpolate(rawMessage, values);
  };
  return i18n;
}
